(() => {
    const $siteMenuBar = document.querySelector('.site-menu-bar');
    const $topMenuItems = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item');
    const $parentSubMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children');
    const $subMenuWraps = document.querySelectorAll('.site-menu-bar > .site-menu > .menu-item-has-children, .site-menu-bar .menu-item-has-children:not(.menu-item--layout-sub-menu-columns) .menu-item-has-children');

    const enableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        if ($subMenuWrap.classList.contains('menu-item--active')) return;

        $subMenuWrap.classList.add('menu-item--active');
        $subMenuToggle.setAttribute('aria-expanded', 'true');
    };

    const disableSubMenu = ($subMenuWrap, $subMenuToggle) => {
        $subMenuWrap.classList.remove('menu-item--active');
        $subMenuToggle.setAttribute('aria-expanded', 'false');
    };

    const initTopMenuItems = () => {
        $topMenuItems.forEach($topMenuItem => {
            $topMenuItem.addEventListener('mouseover', () => {
                $siteMenuBar.classList.add('site-menu-bar--menu-hover');
            });

            $topMenuItem.addEventListener('mouseleave', () => {
                $siteMenuBar.classList.remove('site-menu-bar--menu-hover');
            });
        });
    };

    const initSubMenuDropdowns = () => {
        $parentSubMenuWraps.forEach($subMenuWrap => {
            if (!$subMenuWrap) return;

            const $subMenuToggle = $subMenuWrap.querySelector('a');

            if (!$subMenuToggle) return;

            $subMenuToggle.addEventListener('click', e => {
                e.preventDefault();

                enableSubMenu($subMenuWrap, $subMenuToggle);
            });

            $subMenuWrap.addEventListener('mouseover', e => {
                enableSubMenu($subMenuWrap, $subMenuToggle);
            });

            $subMenuWrap.addEventListener('mouseleave', e => {
                disableSubMenu($subMenuWrap, $subMenuToggle);
            });
        });

        $parentSubMenuWraps.forEach($parentSubMenuWrap => {
            const $subMenuToggle = $parentSubMenuWrap.querySelector('a');

            window.addEventListener('click', e => {
                if ($parentSubMenuWrap.contains(e.target)) return;

                disableSubMenu($parentSubMenuWrap, $subMenuToggle);

                const $activeChildSubMenus = $parentSubMenuWrap.querySelectorAll('.menu-item--active');

                $activeChildSubMenus?.forEach($activeChildSubMenu => {
                    disableSubMenu($activeChildSubMenu, $activeChildSubMenu.querySelector('a'));
                });
            });
        });
    };

    const subMenuOffset = () => {
        const siteMenuBarRightPosition = $siteMenuBar.clientWidth + $siteMenuBar.getBoundingClientRect().left;

        $subMenuWraps.forEach($subMenuWrap => {
            if (!$subMenuWrap) return;

            const $subMenuDropdowns = $subMenuWrap.querySelectorAll('.sub-menu-dropdown');

            if (!$subMenuDropdowns) return;

            $subMenuDropdowns.forEach($subMenuDropdown => {
                $subMenuDropdown.style.marginLeft = '';

                const leftOffset = $subMenuDropdown.getBoundingClientRect().left;
                const rightOffset = leftOffset + $subMenuDropdown.clientWidth;

                if (rightOffset > siteMenuBarRightPosition) {
                    $subMenuDropdown.style.marginLeft = `-${rightOffset - siteMenuBarRightPosition}px`;
                }

                if (leftOffset < 30) {
                    $subMenuDropdown.style.marginLeft = `${-leftOffset}px`;
                }
            });
        });
    };

    window.addEventListener('resize', () => {
        subMenuOffset();
    });

    window.addEventListener('load', () => {
        subMenuOffset();
    });

    initSubMenuDropdowns();
    initTopMenuItems();
    subMenuOffset();
})();
